import { render, staticRenderFns } from "./Specialization.vue?vue&type=template&id=82e40fe0&scoped=true"
import script from "./Specialization.vue?vue&type=script&lang=js"
export * from "./Specialization.vue?vue&type=script&lang=js"
import style0 from "./Specialization.vue?vue&type=style&index=0&id=82e40fe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e40fe0",
  null
  
)

export default component.exports